import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { MILISECONDS_24H } from "models/constants";
import { queryKeys } from ".";

const useDevicePropertiesQuery = () => {
  const query = useQuery(
    queryKeys.devices.properties,
    () => api.lumen.devices.apiDevicesPropertiesGet(),
    {
      cacheTime: MILISECONDS_24H,
      staleTime: MILISECONDS_24H,
    }
  );

  return query;
};

export default useDevicePropertiesQuery;
